// src/context/CartContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [totalPrice, setTotalPrice] = React.useState(parseInt(window.localStorage.getItem("totalPrice")));

    const config = window.APP_CONFIG;

    useEffect(() => {
        const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
        setCart(savedCart);
    }, []);

    const updateLocalStorage = (items) => {
        setCart(items);
        localStorage.setItem("cart", JSON.stringify(items));
    };

    const onPlusClick = (productID, price, inventory = 0, min = 0, max = 0, selectedSku = null) => {
        let cartItems = [...cart];
        setTotalPrice(totalPrice + price)
        window.localStorage.setItem("totalPrice", totalPrice + price);

        let count = min > 0 ? parseInt(min) : 1;

      //  const find_item = cartItems.find(x => x.item === productID);
        const find_item = cartItems.find(x =>
            x.item === productID && x.sku === selectedSku
        );

        if (find_item) {

            if (find_item.count >= inventory && config.shopping_app_settings.ignore_inventory === "0" ) {
                toast.error('امکان خرید بیشتر از این تعداد وجود ندارد');
                return false;
            }

            if (parseInt(max) > 0 && find_item.count >= parseInt(max)) {
                toast.error('امکان خرید بیشتر از این محصول وجود ندارد');
                return false;
            }

            count = find_item.count + 1;

            const objIndex = cartItems.findIndex(obj => obj.item === productID && obj.sku === selectedSku);
            cartItems[objIndex].count = count;
        } else {
            cartItems.push({ item: productID, count , sku: selectedSku });
            if (min > 0) {
                toast.warning(`حداقل تعداد خرید این کالا : ${min} `)
            }
        }

        updateLocalStorage(cartItems);
    };


    const onMinusClick = (productID, min = 0 , selectedSku = null) => {
        let cartItems = [...cart];
        const find_item = cartItems.find(x =>
            x.item === productID && x.sku === selectedSku
        );

        if (find_item) {
            const objIndex = cartItems.findIndex(obj => obj.item === productID && obj.sku === selectedSku);
            if (find_item.count > 1) {
                cartItems[objIndex].count = find_item.count - 1;
            } else {
                cartItems.splice(objIndex, 1);
            }
            if (find_item.count < min) {
                cartItems.splice(objIndex, 1);
            }
            updateLocalStorage(cartItems);
        }
    };

    const getItemCartCount = (productID, selectedSku = null) => {
        const find_item = cart.find(x =>
            x.item === productID && x.sku === selectedSku
        );
        if (find_item) {
            return (find_item.count)
        } else {
            return 0
        }
    }

    const getItemCartCountNoSKU = (productID) => {

        const find_item = cart.find(x =>
            x.item === productID
        );
        if (find_item) {
            return (find_item.count)
        } else {
            return 0
        }
    }

    const massProductIncrease = (productID, price) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        setTotalPrice(totalPrice + price)
        window.localStorage.setItem("totalPrice", totalPrice + price);


        let count = 0 //parseInt(theCount);
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                cartItems[objIndex].count = count;
            } else {
                cartItems.push({'item': productID, 'count': count})
            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            cartItems = [];
            cartItems.push({'item': productID, 'count': count})
        }
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));

  /*      window.localStorage.setItem("companyName", vendor.title);

        setShowCountBox(false);
        setTheCount(0)
        setCountPrice(0)
        setCountId(0)*/
    }
    return (
        <CartContext.Provider value={{ cart, onPlusClick, onMinusClick, getItemCartCount , getItemCartCountNoSKU }}>
            {children}
        </CartContext.Provider>
    );
};
